import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {Router} from '@angular/router';
import {NoticeBoardService} from '../../../modules/notice-board/notice-board.service';
import {NoticeBoard} from '../../../modules/notice-board/notice-board.types';
import {NoticeBoardDialogDetailComponent} from "./dialog-detail/dialog-detail.component";
import {MatDialog} from "@angular/material/dialog";

/** Só limita o que vai para a tela; quantas linhas aparecem quem decide é o tamanho do banner (fitLines). */
const PREVIEW_LIMIT = 600;

@Component({
    selector: 'carousel',
    templateUrl: './carousel.component.html',
    styleUrls: ['./carousel.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CarouselComponent implements OnInit, OnDestroy
{
    notices: NoticeBoard[];
    index: number = 0;
    imageLoaded = false;
    run;

    private _unsubscribeAll: Subject<any> = new Subject<any>();
    private _previews = new Map<string, string>();

    /**
     * Constructor
     */
    constructor(
        private _noticeBoardService: NoticeBoardService,
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _matDialog: MatDialog
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this._noticeBoardService.getAll().subscribe();
        this._noticeBoardService.notices$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((notices: NoticeBoard[]) => {
                this.notices = notices;

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });

        this.carouselChange();
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        clearTimeout(this.run);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Change carrousel in interval 8 sec
     */
    carouselChange(): void
    {
        this.run = setTimeout(() => {
            if (this.index >= this.notices.length - 1) {
                this.index = 0;
                this._changeDetectorRef.markForCheck();
            } else {
                this.next();
            }

            this.carouselChange();
        }, 6000);
    }

    next(): void
    {
        if (this.index >= this.notices.length - 1) {
            return;
        }

        this.index++;

        // Mark for check
        this._changeDetectorRef.markForCheck();
    }

    previous(): void
    {
        if (this.index <= 0) {
            return;
        }

        this.index--;

        // Mark for check
        this._changeDetectorRef.markForCheck();
    }

    goTo(index: number): void {
        this.index = index;
    }

    /**
     * Prévia do aviso em texto puro, cortada em PREVIEW_LIMIT caracteres sem quebrar palavra.
     * A mensagem vem em HTML do Quill; renderizar o HTML no carrossel herdava linhas vazias e cores do texto colado.
     */
    preview(message: string): string
    {
        if (!this._previews.has(message)) {
            // DOMParser monta um documento inerte: não executa script nem carrega imagem da mensagem
            const html = (message || '').replace(/<(br|\/p|\/div|\/li|\/h[1-6])[^>]*>/gi, ' $&');
            const text = (new DOMParser().parseFromString(html, 'text/html').body.textContent || '')
                .replace(/\s+/g, ' ')
                .trim();

            let preview = text;
            if (text.length > PREVIEW_LIMIT) {
                const cut = text.slice(0, PREVIEW_LIMIT);
                const lastSpace = cut.lastIndexOf(' ');
                preview = (lastSpace > 0 ? cut.slice(0, lastSpace) : cut).trimEnd() + '...';
            }

            this._previews.set(message, preview);
        }

        return this._previews.get(message);
    }

    redirect(): void
    {
        this._matDialog.open(NoticeBoardDialogDetailComponent, {
            data: {
                notice: this.notices[this.index]
            },
            width: '100vw',
            height: '100vh',
            maxWidth: '100vw',
            panelClass: 'notice-board-detail-dialog'
        });
        // this._router.navigateByUrl('/mural-de-avisos');
    }

}
